import { Middleware, Dispatch, AnyAction } from 'redux';
import Tracker from 'support/analytics/Tracker';
import { TRACK_PAGE, TRACK_EVENT } from 'actions/analytics/tracking';

const analyticsMiddleware: Middleware = () => (next: Dispatch) => (action: AnyAction) => {
  const { type } = action;

  if (type !== TRACK_PAGE && type !== TRACK_EVENT) {
    return next(action);
  }

  if (type === TRACK_PAGE) {
    Tracker.setVideoData(action.payload);
    Tracker.trackPage(action.payload);
  }

  if (type === TRACK_EVENT) {
    const { eventName, ...rest } = action.payload;
    Tracker.trackEvent(eventName, rest);
  }

  return next(action);
};

export default analyticsMiddleware;
